export default {"src":"/_next/static/media/religious_tours.cb11edb9.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};